module.exports = __webpack_public_path__ + "img/capybara_industries_logo_680px.09b19640.png";